import React, { useState, useEffect } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import AceEditor from 'react-ace'
import Select from 'react-select'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/theme-tomorrow'
import Templates from './Templates'

export const Dcm = (props) => {
  const [ localData, setLocalData ] = useState({dispatcher: {filter: 'CELL_DCM', customHtml: ""}});
  const [ modal, setModal ] = useState(false)

  useEffect(() => {
    if ( !localData.dispatcher ) return;
    
    const { data, setData } = props.parentData;
    setData({...data, dispatcher: [localData.dispatcher]});
  }, [localData]);

  const handleChange = (e, value, key) => {
    let elemValue = !e ? value : e.value;

    const arr = localData.dispatcher ? localData.dispatcher : [];
    setLocalData({...localData, dispatcher: {...arr, [key]: elemValue}});
  }

  return (
    <>
      <div className="block block__dcm">
        <div className="block__body">
          <p className="title">
            <i className="linearicons-code"></i> Tags customizadas
            <span className="title__addon">Obrigatório</span>
          </p>

          <div className="conditions__wrapper">
            <div className="form__group form__group--inline">
              <div className="titled__group">
                <p>Deve ser inserida no elemento:</p>
                <input type="text" className="basic-input" placeholder="Elemento HTML" onChange={(e) => handleChange(e.target, "", "htmlElement")}/>
              </div>
              <div className="titled__group">
                <p>Comportamento:</p>
                <Select
                  options={[
                    {label: "Adicionar ao fim", value: "beforeend"},
                    {label: "Adicionar no início", value: "afterbegin"},
                    {label: "Substituir conteúdo existente", value: "replace"}
                  ]}
                  className="basic-select"
                  classNamePrefix="select"
                  placeholder="Selecione o comportamento"
                  onChange={(e) => {handleChange(e, "", "tagBehavior")}}
                />
              </div>
            </div>
            <div className="form__group form__group--inline">
              <div className="titled__group">
                <p>A página deve conter o elemento:</p>
                <input type="text" className="basic-input" placeholder="Classe ou ID do elemento (pode ser vazio)" onChange={(e) => handleChange(e.target, "", "containHtmlElement")}/>
              </div>
              <div className="titled__group">
                <p>O elemento deve conter o texto:</p>
                <input type="text" className="basic-input" placeholder="Texto do elemento definido" onChange={(e) => handleChange(e.target, "", "containText")}/>
              </div>
            </div>
            <div className="form__group">
              <div className="titled__group">
                <p>Tags:</p>
                <Tabs defaultActiveKey="template" id="uncontrolled-tab">
                  <Tab eventKey="template" title="TEMPLATES">
                    <button type="button" className="btn btn-blue" onClick={() => setModal(true)} style={{marginTop: "15px", marginBottom: "15px"}}>Selecionar template</button>
                  </Tab>
                  <Tab eventKey="html" title="HTML">
                    <AceEditor
                      mode="html"
                      theme="tomorrow"
                      onChange={(e) => handleChange("", e, "customHtml")}
                      name="dcmCustomHtml"
                      editorProps={{$blockScrolling: true}}
                      value={localData.dispatcher.customHtml}
                    />
                  </Tab>
                  <Tab eventKey="css" title="CSS">
                    <AceEditor
                      mode="css"
                      theme="tomorrow"
                      onChange={(e) => handleChange("", e, "customCss")}
                      name="cdmCustonCss"
                      editorProps={{$blockScrolling: true}}
                      value={localData.dispatcher.customCss}
                    />
                  </Tab>
                  <Tab eventKey="js" title="JavaScript">
                    <AceEditor
                      mode="javascript"
                      theme="tomorrow"
                      onChange={(e) => handleChange("", e, "customJs")}
                      name="cdmCustonJs"
                      editorProps={{$blockScrolling: true}}
                      value={localData.dispatcher.customJs}
                    />
                  </Tab>
                </Tabs>
              </div>
            </div>
            <div className="form__group form__group--inline">
              <div className="titled__group">
                <p>Tempo de atividade da tag (em segundos):</p>
                <input type="text" className="basic-input" placeholder="Defina o tempo de permanência do elemento" onChange={(e) => handleChange(e.target, "", "timeout")}/>
              </div>
              <div className="titled__group">
                <p>Recorrência da tag:</p>
                <input type="text" className="basic-input" placeholder="Defina a quantidade de vezes a aparecer" onChange={(e) => handleChange(e.target, "", "recurrence")}/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Templates open={modal} setOpen={setModal} data={localData} setData={setLocalData}/>
    </>
  )
}